import React, { useEffect, useState, useContext, useCallback, useMemo } from "react";
import { Form, Row, Card, CardGroup, Col, Button, Badge, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { trackPromise } from "react-promise-tracker";
import "./ModalNovoTemplate.scss";
import caAPI from "../../../services/caAPI";
import DommusRequiredSpan from "../../../components/DommusRequiredSpan";
import MidiaSocialIcone from "../../../components/MidiaSocialIcone";
import {ModulosContext} from '../../../contexts/ModulosContext';
import {errorToast} from "../../../components/DommusToast";
import EditorDommusTags from "../../../components/EditorDommusTags";
import { TiposAnexosTemplateContext } from "../../../contexts/TiposAnexosTemplateContext";
import { MeioComunicacaoContext } from "../../../contexts/MeioComunicacaoContext";
import { TipoAtendimentoContext } from "../../../contexts/TipoAtendimentoContext";
import { AtendentesContext } from "../../../contexts/AtendentesContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleLeft, faCloudArrowUp, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from "react-select/creatable";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { ExemplosTagsTemplate } from "./ExemplosTagsTemplate";
import { ActionsComponent } from "./ActionsComponent";
import ModalDommus from "../../../components/Modal";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";

export default function ModalNovoTemplate({
  setOpenModalNovoTemplate,
  updateListaTemplates,
  idTemplate,
  handleAtualizaListaTemplates,
}) {

  const [valuesSelectTiposAtendimentos, setValuesSelectTiposAtendimentos] = useState([]);
  const [tiposAtendimentoSelecionado, setTiposAtendimentoSelecionado] = useState([]);
  const [nomeTemplateInput, setNomeTemplateInput] = useState("");
  const [linkTemplateInput, setLinkTemplateInput] = useState(null);
  const [mensagemInput, setMensagemInput] = useState("");
  const [mensagemInputTemplate, setMensagemInputTemplate] = useState("");
  const [selecionadosTemplate, setSelecionadosTemplate] = useState([]);
  const [podeEditar, setPodeEditar] = useState(true);
  const [dadosImagemTemplate, setDadosImagemTemplate] = useState({});
  const [aprovado, setAprovado] = useState(false);
  const [infoTemplateEditar, setInfoTemplateEditar] = useState({});
  const [modelosTags, setModelosTags] = useState([]);
  const [gruposTags, setGruposTags] = useState({});
  const [tiposTemplate, setTiposTemplate] = useState([]);
  const [tipoTemplateSelecionado, setTipoTemplateSelecionado] = useState("");
  const [moduloSelecionado, setModuloSelecionado] = useState("");
  const [modeloTagSelecionado, setModeloTagSelecionado] = useState("");
  const [tipoModeloImpressaoAnexoSelecionado, setTipoModeloImpressaoAnexoSelecionado] = useState("");
  const [modeloImpressaoAnexoSelecionado, setModeloImpressaoAnexoSelecionado] = useState("");
  const [documentosAnexoSelecionados, setDocumentosAnexoSelecionados] = useState([]);
  const {documentosCarregadoAnexos, modelosImpressaoAnexos, resolverNomeDocumentoCarregado} = useContext(TiposAnexosTemplateContext);
  const [assuntoEmail, setAssuntoEmail] = useState('')
  const [copiasEmail, setCopiasEmail] = useState('')
  const [copiasOcultasEmail, setCopiasOcultasEmail] = useState('')
  const [options, setOptions] = useState([]);
  const {modulos} = useContext(ModulosContext);
  const {meiosComunicacao} = useContext(MeioComunicacaoContext);
  const {tiposAtendimento} = useContext(TipoAtendimentoContext);
  const {permitirVisualizarDadosTemplateTwilio, permitirEnviarAprovacaoTemplateTwilio, permitirReenviarAprovacaoTemplateTwilio} = useContext(AtendimentoContext);
  const {listaAtendentes} = useContext(AtendentesContext);
  const [atendentes, setAtendentes] = useState([]);
  const [valuesSelectAtendentes, setValuesSelectAtendentes] = useState([]);
  const [usaSpanEditor, setUsaSpanEditor] = useState(true);
  const [templateSid, setTemplateSid] = useState('')
  const [erroTemplateSid, setErroTemplateSid] = useState(null)
  const [listaModelos, setListaModelos] = useState({})
  const [accountSid, setAccountSid] = useState(null)
  const [idContatoOrigem, setIdContatoOrigem] = useState(null);
  const [contatosOrigem, setContatosOrigem] = useState([]);
  const [manterConversaTwilio, setManterConversaTwilio] = useState(false)
  const [tipoDestinatario, setTipoDestinatario] = useState("C");
  const [destinatariosFixos, setDestinatariosFixos] = useState([]);
  const [statusAprovacaoWhatsapp, setStatusAprovacaoWhatsapp] = useState(null);
  const [openModalExemplosTags, setOpenModalExemplosTags] = useState(false);
  const [actionsRespostas, setActionsRespostas] = useState([]);
  const [categoriaTemplate, setCategoriaTemplate] = useState(null);
  const animatedComponents = makeAnimated();
  const [erroCarregamentoPreview, setErroCarregamentoPreview] = useState(false);

  const handleSelectMeioComunicacao = (midia) => {
    let novoUsaSpan = usaSpanEditor;
    if (!podeEditar) {
      return;
    }
    let value = [...selecionadosTemplate];
    if (selecionadosTemplate.filter((item) => item === midia.id).length) {
      const index = selecionadosTemplate.findIndex((item) => item === midia.id);
      value.splice(index, 1);
      if(midia.slug === 'whatsapp' && !(novoUsaSpan)){
        novoUsaSpan = true;
      }
      if(midia.contatos_origem?.length){
        const novoContatosOrigem = contatosOrigem.filter(
          (origem) =>  {
           return !(midia.contatos_origem.some(
            (contato_excluir) => 
              contato_excluir.id_contato_origem == origem.id_contato_origem
            ));
          }
        );

        setContatosOrigem(novoContatosOrigem);
      }
    } else {
      value.push(midia.id);
      if(midia.slug === 'whatsapp' && (novoUsaSpan)){
        novoUsaSpan = false;
      }
      if(midia.contatos_origem?.length){
        const novoContatosOrigem = contatosOrigem.concat(midia.contatos_origem.slice());
        setContatosOrigem(novoContatosOrigem);
      }
      
    }
    setSelecionadosTemplate(value);
    setUsaSpanEditor(novoUsaSpan);
  };
  

  const meioComunicacaoWhatsapp = useMemo(()=>{
    return meiosComunicacao?.find(meio => meio.slug === 'whatsapp'); 
  },[meiosComunicacao])

  const handleMontarArquivo = function (event) {
    if (event.target.files[0]) {
      let separaTipo = event.target.files[0].type.split("/").pop().split(".");
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onload = function (upload) {
        let dadosArquivo = {
          conteudo: upload.target.result.split(/base64,/)[1],
          nome: file.name,
          tipo: separaTipo[separaTipo.length - 1],
        };
        setDadosImagemTemplate(dadosArquivo);
      };
      file && reader.readAsDataURL(file);
    }
  };

  const contatoOrigemOptions = useMemo(()=>{
    const options = contatosOrigem?.map((origem) => {return {label: origem.descricao, value: origem.id_contato_origem}}) ?? [];
    return [...options, ...(idContatoOrigem ?? [])];
  },[contatosOrigem, idContatoOrigem])

  const optionsDocumentosAnexo = documentosCarregadoAnexos?.map((documento)=>{
      return {
      value: documento.id,
      label: documento.descricao
    }
  });

  const optionsAtendentes = useMemo(()=>{
    return(
      listaAtendentes.map((atendente)=>{
        return {
          value: atendente.id,
          label: atendente.nome,
        }
      })
    )
  },[listaAtendentes])


  useEffect(() => {
    if (selecionadosTemplate.includes(1)) {
      setTiposTemplate(["Texto"]);
      setDadosImagemTemplate({});
      setTipoTemplateSelecionado("Texto");
      return;
    }

    if (selecionadosTemplate.includes(2) || selecionadosTemplate.includes(4)) {
      let tipos = ["Texto", "Texto e Imagem"] ;
      if(selecionadosTemplate.includes(2)){
        tipos.push("Resposta Rápida");
      }
      setTiposTemplate(tipos);
    }

    if (selecionadosTemplate.length === 0) {
      setTiposTemplate([]);
      setDadosImagemTemplate({});
      setTipoTemplateSelecionado("");
    }
  }, [selecionadosTemplate]);

  useEffect(() => {
    let value = [];
    tiposAtendimento &&
    tiposAtendimento?.map((tipo) =>
        value.push({
          value: `${tipo.id}`,
          label: `${tipo.descricao}`,
        })
      );
    setOptions(value);
  }, [tiposAtendimento, idTemplate]);

  const handleEnviarAprovacaoWhatsapp = () => {
    const mensagem = mensagemInput || mensagemInputTemplate;
    const tags = mensagem?.match(/\[[^\[\]]+\]/g);

    if(!idContatoOrigem?.length){
      Swal.fire('Campos obrigatórios não preenchidos!', 'É necessário possuir um contato origem para envio para aprovação', 'warning');
      return;
    }

    if(!tipoTemplateSelecionado){
      Swal.fire('Campos obrigatórios não preenchidos!', 'É necessário selecionar um tipo de template', 'warning');
      return;
    }

    if(!categoriaTemplate){
      Swal.fire('Campos obrigatórios não preenchidos!', 'É necessário selecionar um tipo de template', 'warning');
      return;
    }

    const contatos = idContatoOrigem?.map(item => item?.value);
    const accounts = [...new Set(contatosOrigem?.filter(contato => contatos?.includes(contato.id_contato_origem)).map(contato => contato.account_sid_twilio).filter((value) => value))];
    if(!accounts?.length){
      Swal.fire('Erro na validação!', 'Os ramais escolhidos não possuem vínculo uma conta da twilio. Vincule um Account SID ao ramal selecionado', 'warning');
      return;
    }else if(accounts?.length > 1){
      Swal.fire('Erro na validação!', 'Somente 1 Account SID pode ser vinculado ao Template. Verifique os ramais', 'warning');
      return;
    }

    if (tags && tags.length > 0) {
      setOpenModalExemplosTags(true);
    } else {
      handleSubmitForm({}, true);
    }
  };

  const handleSubmitForm = function (tagsExemplosLocal = null, enviarAprovacaoWhatsapp = false) {
    const meioComunicacaoEmailSelecionado = validarMeioComunicacaoSelecionadoPorSlug('email')
    if (tipoTemplateSelecionado === "Resposta Rápida" && actionsRespostas.length === 0) {
      Swal.fire('Campos obrigatórios não preenchidos!', 'Adicione ao menos uma resposta rápida antes de salvar.', 'warning');
      return;
    }
    if (tipoTemplateSelecionado === "Resposta Rápida" && actionsRespostas.some(resposta => !resposta || Object.values(resposta).some(value => value === null || value === undefined || value === ''))) {
      Swal.fire('Campos obrigatórios não preenchidos!', 'Preencha todos os campos das respostas rápidas antes de salvar.', 'warning');
      return;
    }
    if(meioComunicacaoEmailSelecionado && !assuntoEmail) {
      Swal.fire('Campos obrigatórios não preenchidos!', 'Preencha todos os campos obrigatórios para salvar o template.', 'warning')
      
      return
    }
    let ramais = idContatoOrigem?.map((item) => item?.value);
    const template = {
      nome: nomeTemplateInput,
      tipo_atendimento: tiposAtendimentoSelecionado,
      atendentes: atendentes,
      meio_comunicacao: selecionadosTemplate,
      mensagem: mensagemInput,
      imagem: dadosImagemTemplate,
      tipo_template: tipoTemplateSelecionado,
      aprovado: aprovado ? "S" : "N",
      link: linkTemplateInput,
      tipoModeloImpressao: tipoModeloImpressaoAnexoSelecionado || null,
      modeloImpressao: modeloImpressaoAnexoSelecionado || null,
      documentoAnexo: documentosAnexoSelecionados?.map(documento => {
        return documento.value;
      }),
      id_modulo_tags: moduloSelecionado || null,
      id_modelo_tags: modeloTagSelecionado || null,
      email_assunto: meioComunicacaoEmailSelecionado ? assuntoEmail : null,
      emails_copia: meioComunicacaoEmailSelecionado ? copiasEmail : null,
      emails_copia_oculta: meioComunicacaoEmailSelecionado ? copiasOcultasEmail : null,
      template_sid: validarMeioComunicacaoSelecionadoPorSlug('whatsapp') && templateSid || null,
      account_sid: validarMeioComunicacaoSelecionadoPorSlug('whatsapp') && accountSid || null,
      id_contato_origem: ramais,
      manter_conversa_twilio: manterConversaTwilio && 1 || 0,
      tipo_destinatario: tipoDestinatario ?? 'C',
      destinatarios_fixos: tipoDestinatario === "F" ? destinatariosFixos?.map(destinatario => destinatario.value) : [],
      actions_quick_reply_twilio: tipoTemplateSelecionado === "Resposta Rápida" ? actionsRespostas : [],
      categoria_twilio_template: categoriaTemplate ?? null,
      tags_exemplos_twilio: tagsExemplosLocal ?? null
    };
    caAPI.template
      .create(template, idTemplate)
      .then((res) => {
        updateListaTemplates(res.data);
        if(enviarAprovacaoWhatsapp){
          handleEnviarTemplateAprovacaoWhastapp(tagsExemplosLocal, res.data?.id);
        }else{
          setOpenModalNovoTemplate(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          titleText: "Erro",
          text: "Preencha todos os campos obrigatórios",
          icon: "error",
        });
      })
      .finally(() => handleAtualizaListaTemplates());
  };

  const handleEnviarTemplateAprovacaoWhastapp = (tagsExemplos, id=null) => {
      const payload = {
        tags_exemplos: tagsExemplos,
      }
      trackPromise(caAPI.template.enviarAprovacaoWhatsapp(id ?? idTemplate, payload))
      .then((response) => {
        buscarTemplatePorId(id ?? idTemplate);
        setStatusAprovacaoWhatsapp(response.data);
      }).catch((err) => {
        Swal.fire({
          titleText: "Erro",
          text: "Erro ao enviar template para aprovação do Whatsapp",
          icon: "error",
        });
      });
  }

  const handleChangeTipoTemplate = function (value) {
    setTipoTemplateSelecionado(value);
  };

  const buscarTemplatePorId = function(idTemplate) {
    if (idTemplate) {
      trackPromise(
        caAPI.template
          .buscaPorId(idTemplate)
          .then((res) => {
            const info = JSON.parse(res.data.info);
            setInfoTemplateEditar(info);
            setNomeTemplateInput(res.data.nome);
            setLinkTemplateInput(res.data.link);
            setAssuntoEmail(res.data.email_assunto || '')
            setCopiasEmail(res.data.emails_copia || '')
            setCopiasOcultasEmail(res.data.emails_copia_oculta || '')
            setValuesSelectTiposAtendimentos(
              res.data.tipos?.map((tipos) => ({
                value: tipos.id.toString(),
                label: tipos.descricao,
              }))
            );
            setTemplateSid(res.data.template_sid)
            setAccountSid(res.data.account_sid)
            if(res.data.atendentes && res.data.atendentes.length){
              let arrayAtendentes = [];
              listaAtendentes.forEach(atendente => {
                res.data.atendentes?.forEach(idAtendente => {
                  if (idAtendente === atendente.id) {
                    arrayAtendentes.push(atendente)
                  }
                })
              });
              setValuesSelectAtendentes(arrayAtendentes.map((atendente) => ({
                value: atendente.id,
                label: atendente.nome,
              })));
              setAtendentes(res.data.atendentes);
            }
            const novoContatosOrigem = res.data.meios.reduce((origens, meio) => {
              return origens.concat(meio.contatos_origem || []);  
            }, []);
            setContatosOrigem(novoContatosOrigem);
            setSelecionadosTemplate([...res.data.meios.map((item) => item.id)]);
            setTiposAtendimentoSelecionado(res.data.tipos.map((tipo) => tipo.id));
            setMensagemInput(res.data.mensagem);
            setMensagemInputTemplate(res.data.mensagem);
            setPodeEditar(res.data.permitido_editar);
            setAprovado(res.data.aprovado === "S" ? true : false);
            setTipoTemplateSelecionado(info ? info.tipo : null);
            setDocumentosAnexoSelecionados(JSON.parse(res.data?.id_anexos_documentos_carregados)?.map((id)=>{
              return {
                value: id,
                label: resolverNomeDocumentoCarregado(id)
              }
            }));
            setTipoModeloImpressaoAnexoSelecionado(res.data?.id_anexo_modelo_impressao);
            setModuloSelecionado(res.data?.id_modulo_tags?.toString() || "");
            handleChangeModulo(res.data?.id_modulo_tags?.toString());
            setModeloTagSelecionado(res.data?.id_modelo_tags?.toString() || "");
            handleChangeModeloTags(res.data?.id_modelo_tags, res.data?.id_modulo_tags);
            if(res.data?.id_anexo_modelo_impressao && res.data?.id_modulo_tags){
              handleChangeModelosImpressaoAnexo(res.data?.id_anexo_modelo_impressao, res.data?.id_modulo_tags);
              setModeloImpressaoAnexoSelecionado(res.data?.id_modelo_impressao_modelo);
            }
            setIdContatoOrigem(res?.data?.contato_origem?.map((item) => {return {label: item?.descricao, value: item?.id}}));
            setManterConversaTwilio(res.data?.manter_conversa_twilio == 1)
            setTipoDestinatario(res.data?.tipo_destinatario || "C")
            setDestinatariosFixos(res.data?.destinatarios_fixos?.length ? res.data.destinatarios_fixos?.map(destinatario => ({label: destinatario, value: destinatario})) : [])
            setStatusAprovacaoWhatsapp(res.data?.status_aprovacao_whatsapp || null);
            setCategoriaTemplate(res.data?.categoria_twilio_template || null);
            setActionsRespostas(res.data?.actions_quick_reply_twilio || [])
          })
          .catch((err) => {
            console.log(err)
            Swal.fire({
              titleText: "Erro",
              text: "Houve um problema ao buscar o Template",
              icon: "error",
            });
          })
      );
    }
  }

  useEffect(() => {
    buscarTemplatePorId(idTemplate);
  }, [idTemplate]);

  const resolveBtnEnviarAprovacao = ()=>{
    if(selecionadosTemplate?.includes(meioComunicacaoWhatsapp.id)){
      switch(statusAprovacaoWhatsapp?.status){
        case "received":
        case "pending":
          return (
            <Button 
              variant={'secondary'}  
              className="btn-footer" 
              type="button" 
              disabled
            >
              <FontAwesomeIcon className="mr-1" icon={faWhatsapp}/> 
              Template em Análise 
            </Button>
            )
        case "approved":
          return (
            <Button 
              variant={'success'}  
              className="btn-footer" 
              type="button" 
              disabled
            >
              <FontAwesomeIcon className="mr-1" icon={faWhatsapp}/> 
              Template Aprovado
            </Button>
          )
        case "rejected":
          if(permitirReenviarAprovacaoTemplateTwilio){
            return (
              <Button 
                variant={'warning'}  
                className="btn-footer" 
                type="button" 
                onClick={() => {
                  Swal.fire({
                      position: "center",
                      icon: "question",
                      text: `Deseja habilitar o reenvio do template? Um novo template será criado na twilio`,
                      showCancelButton: true,
                      confirmButtonText: "Sim, habilitar",
                      cancelButtonText: "Não, cancelar",
                      width: "400px",
                      customClass: {
                          confirmButton: "btn btn-success mr-2",
                          cancelButton: "btn btn-secondary",
                      },
                      buttonsStyling: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setTemplateSid("");
                      setStatusAprovacaoWhatsapp(null);
                    }
                  })
                }}
              >
                <FontAwesomeIcon className="mr-1" icon={faWhatsapp}/> 
                Habilitar Reenvio template
              </Button>
            )
          }else{
            return(
              <OverlayTrigger
                  key="overlay-rejeicao-template"
                  overlay={
                      <Tooltip id="tooltip-rejeicao-template">
                          {statusAprovacaoWhatsapp?.rejeicao_mensagem}
                      </Tooltip>
                  }
                  placement="top"
              >
                <Button 
                  variant={'danger'}  
                  className="btn-footer" 
                  type="button" 
                  disabled
                >
                  <FontAwesomeIcon className="mr-1" icon={faWhatsapp}/> 
                  Template Rejeitado Pelo Whatsapp
                </Button>
              </OverlayTrigger>
            )
          }
        default:
          return(
            <Button variant="info" className="btn-footer" type="button" onClick={() => handleEnviarAprovacaoWhatsapp()}>
              <FontAwesomeIcon className="mr-1" icon={faWhatsapp}/> Enviar Aprovação Whastapp 
            </Button>
          )
      }
    }else{
      return <></>
    }
  }

  const badgeAprovacaoWhatsapp = useMemo(()=>{
    switch(statusAprovacaoWhatsapp?.status){
      case "approved":
        return (
          <Badge variant="success" className="ml-2 badge-aprovacao">Template Aprovado Pelo Whatsapp</Badge>
        )
      case "rejected":
        return (
          <OverlayTrigger
              key="overlay-rejeicao-template"
              overlay={
                  <Tooltip id="tooltip-rejeicao-template">
                      {statusAprovacaoWhatsapp?.rejeicao_mensagem}
                  </Tooltip>
              }
              placement="top"
          >
            <Badge variant="danger" className="ml-2 badge-aprovacao" data-tip={statusAprovacaoWhatsapp?.rejeicao_mensagem}>Template Rejeitado Pelo Whatsapp</Badge>
          </OverlayTrigger>
        )
      case "received":
      case "pending":
        return (
          <Badge variant="secondary" className="ml-2 badge-aprovacao">Template em Análise</Badge>
        )
      case "unsubmitted":
        return (
          <Badge variant="dark" className="ml-2 badge-aprovacao">Template não enviado para aprovação</Badge>
        )
      default:
        return(<div></div>)
    }
  },[statusAprovacaoWhatsapp])

  function handleEditorChange(content, editor) {
    content ? setMensagemInput(content) : setMensagemInput(" ");
  }

  function selecionaTipoAtendimento(event) {
    setTiposAtendimentoSelecionado([...event.map((value) => value.value)]);
    setValuesSelectTiposAtendimentos(event);
  }

  function selecionaDocumentosAnexos(event) {
    setDocumentosAnexoSelecionados(event);
  }

  function selecionaAtendente(event) {
    setAtendentes([...event.map((value) => value.value)]);
    setValuesSelectAtendentes(event);
  }

  const handleChangeModulo = (idModulo) => {
    if(idModulo){
      if(moduloSelecionado !== ""){
        const novoGruposTags = {};
        const novoModeloSelecionado = "";
        setGruposTags(novoGruposTags);
        setModeloTagSelecionado(novoModeloSelecionado);
      }
      setModuloSelecionado(idModulo);
      const meioEmail = meiosComunicacao.find((meio) => meio.slug === 'email');
      if(idModulo, meioEmail){
        trackPromise(caAPI.meio_comunicacao.buscarModelosModulo(meioEmail.id, idModulo).then((res) => {
          setModelosTags(res.data || []);
        }).catch(error => errorToast.fire({
          text: "Ocorreu um erro ao buscar os modelos de dado para o meio."
        })));
      }else{
        setModelosTags([]);
        setTipoModeloImpressaoAnexoSelecionado(0);
        setDocumentosAnexoSelecionados([]);
      }
    }else{
      setModuloSelecionado("");
      setModeloTagSelecionado("");
      setModelosTags([]);
      setTipoModeloImpressaoAnexoSelecionado(0);
      setDocumentosAnexoSelecionados([]);
    }

  }

  const handleChangeModeloTags = (idModelo, idModulo=null) => {
    setModeloTagSelecionado(idModelo);
    const meioEmail = meiosComunicacao.find((meio) => meio.slug === 'email');
    if(meioEmail,(moduloSelecionado || idModulo), idModelo){
      trackPromise(caAPI.meio_comunicacao.buscarTagsModelo(meioEmail.id, idModulo, idModelo).then(
        (res) => {
          const novasTags = Object.assign({}, res.data);
          setGruposTags(novasTags);
        }
      ).catch(error => errorToast.fire({
        text: "Ocorreu um erro ao buscar os modelos de dado para o meio."
      })));
    }else{
      const grupos = {};
      setGruposTags(grupos);
    }

  }

  const handleChangeModelosImpressaoAnexo = useCallback((tipoModelo, idModulo=null)=>{
    setTipoModeloImpressaoAnexoSelecionado(tipoModelo);
    if(tipoModelo){
      trackPromise(caAPI.meio_comunicacao.buscarListaModelosPorTipo( tipoModelo, idModulo).then(
        (res) => {
          const modelos = Object.assign({}, res.data);
          setListaModelos(modelos);
        }
      ).catch(error => errorToast.fire({
        text: "Ocorreu um erro ao buscar os modelos de dado para o meio."
      })));
    }else{
      const modelos = {};
      setListaModelos(modelos);
    }
  },[])

  const handleChangeModeloImpressaoAnexo = useCallback((tipoModelo, idModulo=null)=>{
    setModeloImpressaoAnexoSelecionado(tipoModelo);
  },[])

  const editorComponent = useMemo(()=>{
    return (
      <EditorDommusTags
        handleEditorChange={handleEditorChange}
        conteudo={mensagemInputTemplate ?? mensagemInput}
        gruposTags={gruposTags}
        usarSpan={usaSpanEditor}
        disabled={!!templateSid}
      />
    )
  },[gruposTags, usaSpanEditor, templateSid, mensagemInputTemplate])
  

  function validarMeioComunicacaoSelecionadoPorSlug(slug) {
    return meiosComunicacao && selecionadosTemplate.includes(meiosComunicacao?.find(meioComunicacao => meioComunicacao.slug == slug)?.id || 0)
  }

  function validarSidTemplate(templateSid, accountSid = null) {
    trackPromise(caAPI.template.validarSidTemplate(idTemplate, templateSid, accountSid))
      .then(response => {
        setMensagemInput(response.data.mensagem)
        setMensagemInputTemplate(response.data.mensagem)
        setErroTemplateSid(null)
      }).catch(error => {
        setMensagemInputTemplate("");
        setErroTemplateSid('Template SID inválido.')
        console.log(error)
        console.log(error?.response)
      })
  }

  return (
    <>
      <Row className="mb-4" style={{ minHeight: '80vh' }}>
        <Col lg={5}>
          <fieldset>
            <legend>Dados do Template</legend>
            <div className="novoTemplate">
              <Form>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Col}>
                      <Form.Label className="inputLabel mb-2">
                        Meio de Comunicação: <DommusRequiredSpan />
                      </Form.Label>
                      <Form.Control as="checkbox" custom is="x3d">
                        <CardGroup>
                          {meiosComunicacao &&
                            meiosComunicacao?.map((midia) => {
                              let isChecked = null;
                              if (idTemplate && selecionadosTemplate) {
                                isChecked = selecionadosTemplate.filter(
                                  (id) => id === midia.id
                                ).length;
                              }
                              return (
                                <div key={midia.id} style={{ width: '55px', marginRight: '30px' }}>
                                  <Card className="midiaCard">
                                    <Card.Body
                                      className="midiaCorpo"
                                      disabled={podeEditar}
                                    >
                                      <Form.Check
                                        className="midia px-0 pr-2"
                                        type="checkbox"
                                        is="x3d"
                                        id={midia.id}
                                        value={midia.id}
                                      >
                                        <Form.Check.Input
                                          checked={isChecked}
                                          type="checkbox"
                                          is="x3d"
                                        />
                                        <Form.Check.Label
                                          onClick={() => {
                                            handleSelectMeioComunicacao(midia);
                                          }}
                                        >
                                          <MidiaSocialIcone midia={midia.slug} />
                                        </Form.Check.Label>
                                      </Form.Check>
                                    </Card.Body>
                                  </Card>
                                </div>
                              );
                            })}
                        </CardGroup>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Tabs className="tabs-dados-template mx-3">
                      <Tab key={`aba-dados-template`} title={"Dados"} eventKey={'dados-template'} className="p-3 bg-white">
                        <Row>
                          <Form.Group as={Col}>
                            <Form.Label className="inputLabel">
                              Nome do Template: <DommusRequiredSpan />
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={nomeTemplateInput}
                              disabled={!podeEditar}
                              onChange={(event) =>
                                setNomeTemplateInput(event.target.value)
                              }
                              isDisabled={!podeEditar}
                            />
                          </Form.Group>
                        </Row>
                        {validarMeioComunicacaoSelecionadoPorSlug('email') && (<>
                            <Row>
                              <Form.Group as={Col}>
                                <Form.Label className="inputLabel">Assunto do Email <DommusRequiredSpan /></Form.Label>
                                <Form.Control type="text" value={assuntoEmail} onChange={(event) => setAssuntoEmail(event.target.value)} isDisabled={!podeEditar}/>
                              </Form.Group>
                            </Row>
                            <Row>
                              {validarMeioComunicacaoSelecionadoPorSlug('email') && (<>
                                <Form.Group as={Col}>
                                  <Form.Label className="inputLabel">Tipo de Destinatário<DommusRequiredSpan /></Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={tipoDestinatario}
                                    onChange={(event) =>
                                      setTipoDestinatario(event.target.value)
                                    }
                                    disabled={!podeEditar}
                                  >
                                    <option value="C">Cliente</option>
                                    <option value="F">Fixo</option>
                                  </Form.Control>
                                </Form.Group>
                                {tipoDestinatario === "F" && 
                                  <Form.Group as={Col} col={8}>
                                    <Form.Label className="inputLabel">Destinatários</Form.Label>
                                    <CreatableSelect
                                        disabled={!podeEditar}
                                        isMulti
                                        options={[]}
                                        formatCreateLabel={() => `Adicionar`}
                                        className="basic-multi-select"
                                        name="destinatarios-fixos"
                                        placeholder=""
                                        onChange={(event) =>  setDestinatariosFixos(event)}
                                        value={destinatariosFixos}
                                        maxMenuHeight= {190}
                                    />
                                  </Form.Group>
                                }
                              </>)
                              }
                            </Row>
                            <Row>
                              <Form.Group as={Col}>
                                <Form.Label className="inputLabel">CC</Form.Label>
                                <Form.Control type="email" value={copiasEmail} onChange={(event) => setCopiasEmail(event.target.value)} isDisabled={!podeEditar}/>
                              </Form.Group>
                              <Form.Group as={Col}>
                                <Form.Label className="inputLabel">CCO</Form.Label>
                                <Form.Control type="email" value={copiasOcultasEmail} onChange={(event) => setCopiasOcultasEmail(event.target.value)} isDisabled={!podeEditar}/>
                              </Form.Group>
                            </Row>
                          </>) || <></>}
                        <Row>
                          <Form.Group as={Col} xl={6} col={1} className="multiselect">
                            <Form.Label className="inputLabel">
                              Ramais: 
                            </Form.Label>
                            <Select
                              value={idContatoOrigem}
                              options={contatoOrigemOptions}
                              components={animatedComponents}
                              isDisabled={!podeEditar}
                              isMulti
                              name="colors"
                              className="basic-multi-select"
                              classNamePrefix="select"
                              menuPosition={"absolute"}
                              onChange={setIdContatoOrigem}
                              />
                          </Form.Group>
                          <Form.Group as={Col} xl={6} col={1} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Tipo de Atendimento:
                            </Form.Label>
                            {options !== undefined ? (
                              <Select
                                value={valuesSelectTiposAtendimentos}
                                options={options}
                                components={animatedComponents}
                                isDisabled={!podeEditar}
                                isMulti
                                name="colors"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                menuPosition={"absolute"}
                                onChange={(event) => selecionaTipoAtendimento(event)}
                              />
                            ) : (
                              <></>
                            )}
                          </Form.Group>
                          <Form.Group as={Col} xl={6} col={1} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Atendentes:
                            </Form.Label>
                              <Select
                                value={valuesSelectAtendentes}
                                options={optionsAtendentes}
                                components={animatedComponents}
                                isDisabled={!podeEditar}
                                isMulti
                                name="colors"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                menuPosition={"absolute"}
                                onChange={(event) => selecionaAtendente(event)}
                              />
                          </Form.Group>
                        </Row>
                        <Row>
                          <Col md={6}>
                            {badgeAprovacaoWhatsapp}
                          </Col>
                          <Form.Group as={Col} md={6} controlId="checkbox-manter-conversa-twilio" className="row justify-content-between px-4">
                            <Form.Check
                              type="checkbox"
                              className="mx-2"
                              label={<Form.Label className="inputLabel">&nbsp;Manter conversa pós envio</Form.Label>}
                              onChange={(event) => setManterConversaTwilio(event.target.checked)}
                              checked={manterConversaTwilio}
                            />
                          </Form.Group>
                        </Row>
                      </Tab>
                      <Tab key={`aba-dados-tags`} title={"Dados Tags"} eventKey={'dados-tags'}  className="p-3 bg-white">
                        {validarMeioComunicacaoSelecionadoPorSlug('whatsapp') && !!permitirVisualizarDadosTemplateTwilio ? (
                          <Row>
                            <Form.Group as={Col}>
                              <Form.Label className="inputLabel">Account SID:</Form.Label>
                              <Form.Control type="text" 
                                value={accountSid} 
                                onChange={(event) => setAccountSid(event.target.value)} 
                                isDisabled={!podeEditar} 
                                onBlur={(e) => templateSid && validarSidTemplate(templateSid, e.target.value)}
                              />
                            </Form.Group>
                            <Form.Group as={Col}>
                              <Form.Label className="inputLabel">Template SID:</Form.Label>
                              <Form.Control type="text" 
                                value={templateSid} 
                                onChange={(event) => setTemplateSid(event.target.value)} 
                                isDisabled={!podeEditar} 
                                onBlur={(e) => validarSidTemplate(e.target.value, accountSid)}
                              />
                              {erroTemplateSid && <small className="form-text text-danger"><FontAwesomeIcon icon={faExclamationTriangle}/> {erroTemplateSid}</small>}
                            </Form.Group>
                          </Row>
                        ) : <></>}
                        <Row>
                        <Form.Group as={Col} col={2} controlId="formAtendimento">
                          <Form.Label className="inputLabel">
                            Tipo de Template: <DommusRequiredSpan />
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={tipoTemplateSelecionado}
                            onChange={(event) =>
                              handleChangeTipoTemplate(event.target.value)
                            }
                            disabled={!podeEditar}
                          >
                            <option value="" disabled>
                              Selecione um Tipo de Template
                            </option>
                            {tiposTemplate?.map((tipoTemplate) => {
                              return (
                                <option key={tipoTemplate} value={tipoTemplate}>{tipoTemplate}</option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xl={6} col={2} controlId="formAtendimento">
                          <Form.Label className="inputLabel">
                            Usar tags do Módulo:
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={moduloSelecionado}
                            onChange={(event) =>
                              handleChangeModulo(event.target.value)
                            }
                            disabled={!podeEditar}
                          >
                            <option value="">
                              Selecione um modulo para buscar as tags
                            </option>
                            {modulos?.map((modulo) => {
                              return (
                                <option key={modulo.id} value={modulo.id}>{modulo.nome}</option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                        {moduloSelecionado && 
                          <Form.Group as={Col} md={6} col={2} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Tipo de Modelo:
                            </Form.Label>
                            <Form.Control
                              as="select"
                              value={modeloTagSelecionado}
                              onChange={(event) =>
                                handleChangeModeloTags(event.target.value, moduloSelecionado)
                              }
                              disabled={!podeEditar}
                              >
                              <option value="" hidden>
                                Selecione um modelo para buscar as tags
                              </option>
                              {modelosTags?.map((modelo) => {
                                return (
                                  <option key={modelo.id_tipo_modelo_contratual} value={modelo.id_tipo_modelo_contratual}>{modelo.descricao}</option>
                                );
                              })}
                            </Form.Control>
                          </Form.Group>
                        }
                        {moduloSelecionado === "2" &&
                          <Form.Group as={Col} xl={6} col={2} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Tipo de Modelo para Anexo:
                            </Form.Label>
                            <Form.Control
                              as="select"
                              value={tipoModeloImpressaoAnexoSelecionado}
                              onChange={(event) =>
                                handleChangeModelosImpressaoAnexo(event.target.value, moduloSelecionado)
                              }
                              disabled={!podeEditar}
                              >
                              <option value="">
                                Selecione um anexo de impressão
                              </option>
                              {modelosImpressaoAnexos?.map((modelo) => {
                                return (
                                  <option key={modelo.id_tipo_modelo_contratual} value={modelo.id_tipo_modelo_contratual}>{modelo.descricao}</option>
                                );
                              })}
                            </Form.Control>
                          </Form.Group>
                        }
                        {moduloSelecionado === "2" &&
                          <Form.Group as={Col} xl={6} col={2} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Modelo para Anexo:
                            </Form.Label>
                            <Form.Control
                              as="select"
                              value={modeloImpressaoAnexoSelecionado}
                              onChange={(event) =>
                                handleChangeModeloImpressaoAnexo(event.target.value, moduloSelecionado)
                              }
                              disabled={!podeEditar}
                              >
                              <option value="">
                                Selecione um anexo de impressão
                              </option>
                              {Object.values(listaModelos)?.map((modelo) => {
                                return (
                                  <option key={modelo.id_modelo_contratual} value={modelo.id_modelo_contratual}>{modelo.titulo}</option>
                                );
                              })}
                            </Form.Control>
                          </Form.Group>
                        }
                        {moduloSelecionado === "2" &&
                          <Form.Group as={Col} xl={6} col={1} controlId="formAtendimento">
                            <Form.Label className="inputLabel">
                              Tipo de Documento para Anexo:
                            </Form.Label>
                            {optionsDocumentosAnexo !== undefined ? (
                              <Select
                                value={documentosAnexoSelecionados}
                                options={optionsDocumentosAnexo}
                                components={animatedComponents}
                                isMulti
                                name="colors"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                menuPosition={"absolute"}
                                onChange={(event) => selecionaDocumentosAnexos(event)}
                                isDisabled={!podeEditar}
                              />
                            ) : (
                              <></>
                            )}
                          </Form.Group>
                        }
                          {validarMeioComunicacaoSelecionadoPorSlug('whatsapp') && (
                            <Form.Group as={Col} md={6} col={2} controlId="formAtendimento">
                              <Form.Label className="inputLabel">
                                Categoria do Template: <DommusRequiredSpan />
                              </Form.Label>
                              <Form.Control
                                as="select"
                                value={categoriaTemplate}
                                onChange={(event) =>
                                  setCategoriaTemplate(event.target.value)
                                }
                                disabled={!podeEditar}
                                >
                                <option value="" hidden>
                                  Selecione a categoria do template
                                </option>
                                <option value="MARKETING">Marketing</option>
                                <option value="UTILITY">Utilidades</option>
                              </Form.Control>
                            </Form.Group>
                          )}
                          {tipoTemplateSelecionado === "Resposta Rápida" && (
                            <Col lg={12}>
                              <ActionsComponent
                                actionsRespostas={actionsRespostas}
                                setActionsRespostas={setActionsRespostas}
                              />
                            </Col>
                          )}
                          {tipoTemplateSelecionado === "Texto e Imagem" && (
                            <>
                              <Col lg={12}>
                                <Form.Group>
                                  <Form.Label className="inputLabel">
                                    Anexar arquivo:
                                  </Form.Label>
                                  <Form.Control type={"file"}
                                    id="formcheck-api-regular"
                                    data-browse="Procurar"
                                    onChange={(event) => handleMontarArquivo(event)}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={12}>
                                <Form.Group>
                                  <Form.Label className="inputLabel">
                                    Link:
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={linkTemplateInput}
                                    disabled={!podeEditar}
                                    onChange={(event) =>
                                      setLinkTemplateInput(event.target.value)
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={12}>
                             {infoTemplateEditar.imagem?.url ? (
                                erroCarregamentoPreview ? (
                                  <a href={infoTemplateEditar.imagem.url} 
                                    className="text-decoration-none text-reset bg-light p-2 border rounded d-inline-block"
                                    target="_blank" 
                                    rel="noopener noreferrer p-2 bor">Ver anexo</a>
                                ) : (
                                  <img
                                    src={infoTemplateEditar.imagem.url}
                                    alt=""
                                    class="mw-100"
                                    onError={() => setErroCarregamentoPreview(true)}
                                  />
                                )
                              ) : (
                                ""
                              )}
                              </Col>
                            </>
                          )}
                        </Row>
                      </Tab>
                      {
                        // Tab para mostrar logs que poderão acontecer nos templates
                        // <Tab key={`aba-logs`} title={"Logs"} eventKey={'logs'} className="p-3 bg-white">
                        // </Tab>
                      }
                    </Tabs>
                  </Col>
                </Row>
              </Form>
            </div>
          </fieldset>
        </Col>
        <Col className="editorMensagem" md="7" sm="12">
          <fieldset className="p-3">
              <legend>Mensagem</legend>
            {
              editorComponent
            }
          </fieldset>
        </Col>
      </Row>
      <Row>
        <Col className="novoTemplate border-top">
          <div className="buttonsTemplate" style={{ justifyContent: selecionadosTemplate?.includes(meioComunicacaoWhatsapp?.id) ? 'space-between' : 'flex-end' }}>
            {permitirEnviarAprovacaoTemplateTwilio ?  resolveBtnEnviarAprovacao() : <div></div>}
            <div>
              <Button variant="secondary" className="submitTemplate fecharModal" type="button" onClick={() => setOpenModalNovoTemplate(false)}>
                <FontAwesomeIcon className="mr-1" icon={faArrowAltCircleLeft}/> Fechar
              </Button>
              <Button className="submitTemplate" onClick={() => handleSubmitForm()} >
                <FontAwesomeIcon className="mr-1" icon={faCloudArrowUp} /> Salvar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <ModalDommus
        titulo="Envio aprovação Whatsapp"
        open={openModalExemplosTags}
        close={()=>{setOpenModalExemplosTags(false)}}
        size="md"
      >
        <ExemplosTagsTemplate
          mensagem={mensagemInput || mensagemInputTemplate}
          handleSubmitForm={handleSubmitForm}
          closeModal={() => setOpenModalExemplosTags(false)}
        />
      </ModalDommus>
    </>
  );
}
